import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BuddyLogo, LumiMascot } from "../components/Brand";
import { Button } from "../components/ui/button";
import api from "../lib/api";

export default function PaymentSuccess() {
  const { t } = useTranslation();
  const [sp] = useSearchParams();
  const sessionId = sp.get("session_id");
  const [status, setStatus] = useState(null);
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sessionId) return;
    let cancel = false;
    async function poll() {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (cancel) return;
        setStatus(r.data);
        if (r.data.payment_status !== "paid" && tries < 20) setTimeout(() => setTries((x) => x + 1), 1500);
      } catch (err) {
        console.warn("Payment status poll failed", err);
        if (tries < 20) setTimeout(() => setTries((x) => x + 1), 3000);
        else setStatus({ payment_status: "unknown", error: true });
      }
    }
    poll();
    return () => { cancel = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tries, sessionId]);

  const paid = status?.payment_status === "paid";
  const errored = status?.error === true || status?.payment_status === "unknown";
  let statusHeading;
  let statusBody;
  if (paid) {
    statusHeading = t("payments.received");
    statusBody = t("payments.activeNow");
  } else if (errored) {
    statusHeading = t("payments.couldntConfirm");
    statusBody = t("payments.couldntConfirmBody");
  } else {
    statusHeading = t("payments.confirming");
    statusBody = t("payments.wait");
  }
  return (
    <div className="min-h-screen student-bg flex flex-col">
      <header className="p-6"><Link to="/"><BuddyLogo /></Link></header>
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="hb-card p-10 max-w-lg w-full text-center hb-chunky-shadow">
          <div className="flex justify-center"><LumiMascot size={140} /></div>
          <h1 className="font-adult font-bold text-3xl text-slate-900 mt-2" data-testid="payment-status-heading">
            {statusHeading}
          </h1>
          <p className="text-slate-600 mt-2">{statusBody}</p>
          <div className="text-xs text-slate-400 mt-3 font-mono break-all">{sessionId}</div>
          <div className="mt-6 flex justify-center gap-2 flex-wrap">
            <Link to="/app"><Button className="bg-slate-900 hover:bg-slate-800 text-white rounded-full" data-testid="payment-success-goto-app">{t("activation.goToApp")}</Button></Link>
            <Link to="/pricing"><Button variant="outline" className="rounded-full" data-testid="payment-success-see-plans">{t("payments.seePlans")}</Button></Link>
            {errored && <Link to="/legal/support"><Button variant="outline" className="rounded-full" data-testid="payment-success-contact">{t("payments.contactSupport")}</Button></Link>}
          </div>
        </div>
      </main>
    </div>
  );
}
